export default {
  namespaced: true,
  state: {
    path: null,
    pathArrayForDisplay: [],
    searchKeyword: null,
    isSearchMode: false,
  },
  mutations: {
    SET_PATH(state, payload) {
      state.path = payload;
    },
    SET_PATH_ARRAY_FOR_DISPLAY(state, payload) {
      state.pathArrayForDisplay = payload;
    },
    SET_SEARCH_KEYWORD(state, payload) {
      state.searchKeyword = payload;
    },
    SET_IS_SEARCH_MODE(state, payload) {
      state.isSearchMode = payload;
    },
    INIT(state) {
      state.path = null;
      state.pathArrayForDisplay = [];
      state.searchKeyword = null;
      state.isSearchMode = false;
    },
  },
  getters: {
    getPath(state) {
      return state.path;
    },
    getPathArrayForDisplay(state) {
      return state.pathArrayForDisplay;
    },
    getSearchKeyword(state) {
      return state.searchKeyword;
    },
    getIsSearchMode(state) {
      return state.isSearchMode;
    }
  },
  actions: {
    setPath({commit}, payload) {
      commit('SET_PATH', payload);
    },
    setPathArrayForDisplay({commit}, payload) {
      commit('SET_PATH_ARRAY_FOR_DISPLAY', payload);
    },
    setSearchKeyword({commit}, payload) {
      commit('SET_SEARCH_KEYWORD', payload);
    },
    setIsSearchMode({commit}, payload) {
      commit('SET_IS_SEARCH_MODE', payload);
    },
    init({commit}) {
      commit('INIT');
    },
  },
}